import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { CompensationStatus, Namespace } from 'enums';

import styles from './CompensationStatusItem.module.scss';

interface Props {
  status: CompensationStatus;
}

export const CompensationStatusItem = ({ status }: Props) => {
  const { t } = useTranslation(Namespace.CompensationStatuses);
  const label = t(status);

  return <div className={classNames(status, styles.status)}>{label}</div>;
};
